import React, { useCallback } from 'react';
import styled from 'styled-components';

import DataPair from 'shared/components/DataPair';
import LabeledContent from 'shared/components/LabeledContent';
import TextField from 'shared/components/TextField';
import { formatDate } from 'shared/utils';
import { formatWorkflowTypeString } from 'shared/utils/api/mappers/workflowMapper';

import { WorkflowDetailsProps } from './types';
import {
  WORKFLOW_NAME_KEY,
  WORKFLOW_TYPE_KEY,
  WORKFLOW_CREATION_DATE_KEY,
  WORKFLOW_STATUS_KEY,
  WORKFLOW_NAME_MAX_CHARACTERS,
} from './constants';

const WORKFLOW_NAME_INPUT_CONTAINER_CLASS_NAME = 'workflow-name-input-container';
const WORKFLOW_NAME_INPUT_CLASS_NAME = 'workflow-name-input';

const StyledContainer = styled.div`
  display: flex;
`;

const StyledContentContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;

  &:not(:last-child) {
    margin-bottom: 2.2rem;
  }
`;

const StyledWorkflowNameOuterContainer = styled(StyledContentContainer)`
  flex-basis: 37rem;
  margin-right: 10.4rem;
`;

const StyledWorkflowTypeOuterContainer = styled(StyledContentContainer)``;

const StyledWorkflowNameContainer = styled(LabeledContent)`
  width: 100%;
`;

const StyledTextField = styled(TextField)`
  width: 100%;

  & {
    .${WORKFLOW_NAME_INPUT_CONTAINER_CLASS_NAME} {
      height: 3.7rem;
    }

    .${WORKFLOW_NAME_INPUT_CLASS_NAME} {
      font-size: 1.2rem;
    }
  }
`;

const StyledDataPair = styled(DataPair)`
  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }
`;

const WorkflowDetails = ({
  onChange,
  values,
}: WorkflowDetailsProps) => {
  const handleTextInputChange = useCallback((event) => {
    onChange(event.target.value, WORKFLOW_NAME_KEY);
  }, [onChange]);

  return (
    <StyledContainer>
      <StyledWorkflowNameOuterContainer>
        <StyledWorkflowNameContainer label='Workflow Name'>
          <StyledTextField
            isDisabled
            textInputContainerClassName={WORKFLOW_NAME_INPUT_CONTAINER_CLASS_NAME}
            textInputClassName={WORKFLOW_NAME_INPUT_CLASS_NAME}
            onChange={handleTextInputChange}
            value={values.name}
            maxLength={WORKFLOW_NAME_MAX_CHARACTERS}
          />
        </StyledWorkflowNameContainer>
      </StyledWorkflowNameOuterContainer>
      <StyledWorkflowTypeOuterContainer>
        <StyledDataPair label='Type'>{formatWorkflowTypeString(values[WORKFLOW_TYPE_KEY])}</StyledDataPair>
        {values[WORKFLOW_CREATION_DATE_KEY] && (
          <StyledDataPair label='Creation Date'>
            {formatDate(values[WORKFLOW_CREATION_DATE_KEY])}
          </StyledDataPair>
        )}
      </StyledWorkflowTypeOuterContainer>
    </StyledContainer>
  );
};

export default WorkflowDetails;
